var _a;

import { SvgIcon } from '@nextiva/next-ui';
import cx from 'classnames';
import React from 'react';
import { CardTypeIcons } from "../../constants";
import diagramIcon from './assets/icons/diagram.svg';
import pieIcon from './assets/icons/pie.svg';
import Styles from "./ChartPlaceholder.css";
var icons = (_a = {}, _a[CardTypeIcons.DIAGRAM] = diagramIcon, _a[CardTypeIcons.PIE] = pieIcon, _a);

function ChartPlaceholder(_a) {
  var className = _a.className,
      style = _a.style,
      _b = _a.size,
      size = _b === void 0 ? 'small' : _b,
      _c = _a.icon,
      icon = _c === void 0 ? CardTypeIcons.PIE : _c;

  var _d;

  var fullClassName = cx(className, Styles.chartPlaceholder, (_d = {}, _d[Styles.large] = size === 'large', _d[Styles.small] = size === 'small', _d));
  return React.createElement("div", {
    className: fullClassName,
    style: style
  }, React.createElement(SvgIcon, {
    className: Styles.icon,
    src: icons[icon]
  }));
}

export default ChartPlaceholder;